// extracted by mini-css-extract-plugin
module.exports = {"TrendingButtons":"styles_TrendingButtons__OOaj1","btn":"styles_btn__yWUBa"};